import type { BenchmarkSummary } from "./types";

export const BENCHMARK_SUMMARY: BenchmarkSummary = {
  version: "JarLab regression corpus 2026.07.24-v8",
  totalCases: 27,
  maliciousCases: 10,
  cleanControls: 6,
  mutationCases: 5,
  expectedOutcomesPassed: 27,
  falsePositiveControlsPassed: 6,
  scope:
    "Deterministic unit, synthetic archive, repack, encoded-string, nested payload, integrity, fingerprint, and clean-control cases.",
  disclaimer:
    "This is a release regression suite, not a measured real-world detection rate. It must not be read as 100% malware coverage.",
};
